export const getRedirectUrlWithStatus = (url: string, status: string): string => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}status=${status}`;
}; 